import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getProvidersExpertise = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit != null && `limit=${limit}`, offset != null && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/providers-expertise?${queryParts.join("&")}`;
  const { data: providersExpertise } = await axios.get(url);
  return providersExpertise;
};

export const removeProviderExpertise = async (providerExpertiseId) => {
  const { data: removedProviderExpertise } = await axios.delete(`/providers-expertise/${providerExpertiseId}`);
  return removedProviderExpertise;
};

export const addProviderExpertise = async (providerExpertise) => {
  const { data: addedProviderExpertise } = await axios.post(`/providers-expertise`, {
    data: providerExpertise,
  });
  return addedProviderExpertise;
};

export const updateProviderExpertise = async ({ id, ...providerExpertiseData }) => {
  const { data: updatedProviderExpertise } = await axios.put(`/providers-expertise/${id}`, {
    data: providerExpertiseData,
  });
  return updatedProviderExpertise;
};
